import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

/**
 * Legal pages API service
 * All public endpoints — no auth required
 * Fetches Privacy Policy, Terms of Service, Cookie Policy from backend
 */
const legalApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

const legalService = {
  /**
   * Get summary of all active legal pages (no full content)
   * @returns {{ success: boolean, count: number, pages: Array }}
   */
  getAllPages: async () => {
    try {
      const { data } = await legalApi.get("/legal");
      return data;
    } catch (error) {
return { success: false, count: 0, pages: [] };
    }
  },

  /**
   * Get a specific legal page with full content & sections
   * @param {'privacy-policy' | 'terms-of-service' | 'cookie-policy'} type
   * @returns {{ success: boolean, page: object|null }}
   */
  getPage: async (type) => {
    try {
      const { data } = await legalApi.get(`/legal/${type}`);
      return data;
    } catch (error) {
return {
        success: false,
        page: null,
        message: error.response?.data?.message || "Failed to load page",
      };
    }
  },

  /** Convenience methods */
  getPrivacyPolicy: () => legalService.getPage("privacy-policy"),
  getTermsOfService: () => legalService.getPage("terms-of-service"),
  getCookiePolicy: () => legalService.getPage("cookie-policy"),
};

export default legalService;
